<div *ngIf="active" class="tab">
	<div class="content">
	  <ng-content></ng-content>
	</div>
</div>